import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from "vuex";
import TemplateCard from "@Broker/@Modules/marketing/templates/components/template-card.vue";
import { encode64 } from "@Broker/js/custom/utils";
import Loader from "@Shared/utils/preload";
import { showToast } from "@Shared/@Utils/constants";
import { LOAD_MARKETING_TEMPLATE, UPDATE_TEMPLATE, CREATE_TEMPLATE, UPDATE_CURRENT_TEMPLATE } from "../../store/templates/templates-actions";
import HtmlTemplateEditor from "@Broker/@Modules/util-components/html-template-editor.vue";
import Amplitude from "@Shared/@Utils/amplitude";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "MarketingCampaignTemplateSelect",
  components: {
    TemplateCard,
    HtmlTemplateEditor
  },
  props: {
    showTemplate: {
      type: Boolean,
      required: true
    },
    campaignDetails: {
      type: Object,
      required: true
    },
    create: {
      type: Boolean,
      required: true
    },
    editable: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      bee: {},
      goSelectTemplate: {
        path: "/marketing/templates",
        query: {
          fromCampaign: true,
          selectPage: true,
          backPath: `/marketing/campaigns/${this.campaignDetails.campaignId}`
        }
      },
      showSavedMessage: false,
      previewTemplate: false,
      templateSourceUrl: ""
    };
  },
  computed: _objectSpread({}, mapState("TemplatesStore", ["currentTemplate"])),
  methods: _objectSpread(_objectSpread({}, mapActions("TemplatesStore", [LOAD_MARKETING_TEMPLATE, UPDATE_TEMPLATE, CREATE_TEMPLATE, UPDATE_CURRENT_TEMPLATE])), {}, {
    handleTemplateEdit() {
      this.handleOpenBeeEditor("edit");
      Amplitude.logEvent("Campaigns - edit marketing template card clicked");
    },
    handleTemplatePreview() {
      this.handleOpenBeeEditor("preview");
      Amplitude.logEvent("Campaigns - preview marketing template card clicked");
    },
    handleTemplateDelete() {
      this.$emit("template-delete");
      Amplitude.logEvent("Campaigns - delete marketing template card clicked");
    },
    async handleOpenBeeEditor(type) {
      this.previewTemplate = type === "preview";
      this.UPDATE_CURRENT_TEMPLATE(_objectSpread(_objectSpread({}, this.currentTemplate), {}, {
        templateId: this.campaignDetails.templateId
      }));
      await this.LOAD_MARKETING_TEMPLATE(this.campaignDetails.templateId);
      await this.$nextTick();
      this.templateSourceUrl = this.currentTemplate.url;
      this.showSavedMessage = false;
      this.$refs.templateEditorContainer.mountPlugin();
    },
    handleEditorHidden() {
      this.previewTemplate = false;
      this.templateSourceUrl = "";
    },
    async onSaveHandler({
      jsonTemplate,
      htmlTemplate
    }) {
      const json = encode64(jsonTemplate);
      const html = encode64(htmlTemplate);
      await this.UPDATE_TEMPLATE({
        templateId: this.campaignDetails.templateId,
        data: {
          json,
          html
        }
      });
      if (this.showSavedMessage) showToast("success", "templateSaved");else this.showSavedMessage = true;
      Loader.stop();
    }
  })
});